const REMOTE_LAT = 25.0;
const REMOTE_LON = -40.0;

/**
 * Small epsilon value for floating-point comparison tolerance.
 * This accounts for potential precision differences in coordinate data.
 */
const EPSILON = 1e-10;

export function isRemoteLocation(latitude: number, longitude: number): boolean {
  return Math.abs(latitude - REMOTE_LAT) < EPSILON && Math.abs(longitude - REMOTE_LON) < EPSILON;
}

export function isRemoteLocationSafe(latitude?: number, longitude?: number): boolean {
  return isRemoteLocation(latitude ?? 0, longitude ?? 0);
}
